import { IDetailPageData } from "../../../shared/utils/api";

export interface IEventDatamodelField {
  id: string;
  input_field_name: string;
  field_name: string;
  field_datatype: string;
  primary_key?: string;
  datetime_format?: string;
  text_type?: string;
  archived?: boolean;
  distinct_values?: number;
  empty_values?: number;
  null_values?: number;
  total_rows?: number;
}

export interface IEventBackendType {
  id: string;
  name: string;
  datetime_format?: string;
  csv_separator?: string;
  fields: IEventDatamodelField[];
  alertcase_id: string,
  alertcase_field_id: string,
  alertcase_label_field_id: string,
  alertcase_list_id: string,
  label_list_id: string,
  alertcase_name?: string,
  alertcase_field_name?: string,
  alertcase_label_field_name?: string,
  alertcase_list_name?: string,
  label_list_name?: string,
  archived?: boolean;
  enable_scoring?: string;
  total_rows?: number;
}

export function transformToBackendEvent(data: IDetailPageData): IEventBackendType | undefined {
  if (!data.id || !data.name) {
    return undefined;
  }

  return {
    id: data.id,
    datetime_format: data.datetime_format,
    archived: data.archived,
    csv_separator: data.csv_separator,
    alertcase_id: data.alertcase_id,
    alertcase_field_id: data.alertcase_field_id,
    alertcase_label_field_id: data.alertcase_label_field_id,
    alertcase_list_id: data.alertcase_list_id,
    label_list_id: data.label_list_id,
    name: data.name,
    enable_scoring: data.enable_scoring,
    fields: data.rowData.map(field => {
      let result:IEventDatamodelField = {      
        id: field.id,
        input_field_name: field.input_field_name,
        field_name: field.field_name,
        field_datatype: field.field_datatype
      };
      if (field.field_datatype === "text") {
        result = {...result, text_type: field.text_type };
      }

      if ((field.text_type && field.text_type !== "long_text" && field.field_datatype === "text") || field.field_datatype === "integer") {
        result = {...result, primary_key: field.primary_key };
      }

      if (field.field_datatype === "datetime") {
        result = {...result, datetime_format: field.datetime_format };
      }

      return (result);
    })
  };
}

export function transformFromBackendEvent(backendType: IEventBackendType): IDetailPageData {
  return {
    id: backendType.id,
    name: backendType.name,
    archived: backendType.archived,
    alertcase_id: backendType.alertcase_id,
    alertcase_field_id: backendType.alertcase_field_id,
    alertcase_label_field_id: backendType.alertcase_label_field_id,
    alertcase_list_id: backendType.alertcase_list_id,
    label_list_id: backendType.label_list_id,

    alertcase: backendType.alertcase_name,
    alertcase_field: backendType.alertcase_field_name,
    alertcase_label_field: backendType.alertcase_label_field_name,
    alertcase_list: backendType.alertcase_list_name,
    label_list: backendType.label_list_name,
    enable_scoring: backendType.enable_scoring,

    datetime_format: backendType.datetime_format,
    csv_separator: backendType.csv_separator,
    rowData: backendType.fields.map(field => {
      let result: any = { // eslint-disable-line
        id: field.id,
        input_field_name: field.input_field_name,
        field_name: field.field_name,
        field_datatype: field.field_datatype,
        empty_values: field.empty_values,
        null_values: field.null_values,
        unique_values: field.distinct_values,
        primary_key: field.primary_key,
        total_rows: field.total_rows ?? backendType.total_rows      
      };

      if (field.field_datatype === "text") {
        result = {...result, text_type: field.text_type };
      }

      if ((field.text_type && field.text_type !== "long_text" && field.field_datatype === "text") || field.field_datatype === "integer") {
        result = {...result, primary_key: field.primary_key };
      }

      if (field.field_datatype === "datetime") {
        result = {...result, datetime_format: field.datetime_format };
      }

      return (result);
    })
  };
}